import { auth, provider } from "./Firebase";
import { signInWithPopup } from "firebase/auth";

export default function Logingoogle() {
    function submit(e) {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const number = formData.get("number");
        // Currently unused: you'd need Firebase Phone Auth for OTP flow
        console.log("Phone login attempted:", number);
    }

    function submit2(e) {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const otp = formData.get("otp");
        console.log("OTP entered:", otp);
    }

    function login() {
        signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                console.log("Google Login Success:", user);
            })
            .catch((error) => {
                console.error("Google Login Failed:", error.message);
            });
    }

    return (
        <div className="row m-0 p-5 d-flex justify-content-center align-items-center">
            <h1 className="text-center text-primary fw-bold mb-5">LOGIN WITH OTHER OPTIONS</h1>

            <div className="col-lg-4">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={submit}>
                            <input type="number" name="number" placeholder="Number" className="form-control mb-2" />
                            <button className="btn btn-primary">Login</button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="col-lg-4">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={submit2}>
                            <input type="number" name="otp" placeholder="OTP" className="form-control mb-2" />
                            <button className="btn btn-primary">Login</button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="text-center my-3">or</div>

            <div className="col-lg-12 p-4 text-center">
                <button onClick={login} className="btn btn-danger fw-bold">Login With Google</button>
            </div>
        </div>
    );
}
